import WebApp from "@twa-dev/sdk";

type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft";
type NotificationType = "error" | "success" | "warning";

export function useHaptic() {
  const impact = (style: ImpactStyle = "light") => {
    try {
      WebApp.HapticFeedback?.impactOccurred(style);
    } catch { /* haptics unsupported on this platform */ }
  };

  const notification = (type: NotificationType) => {
    try {
      WebApp.HapticFeedback?.notificationOccurred(type);
    } catch { /* haptics unsupported on this platform */ }
  };

  const selection = () => {
    try {
      WebApp.HapticFeedback?.selectionChanged();
    } catch { /* haptics unsupported on this platform */ }
  };

  return { impact, notification, selection };
}
